import getDomainMapExercisesSelect from '../get-domain-map'
import { createSelector } from 'reselect'

function getByIdExerciseSelector (id) {
  return createSelector(
    getDomainMapExercisesSelect,
    (domainMap) => domainMap[id]
  )
}

export default getByIdExerciseSelector
